<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDeny_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M22.44 24.56a1.5 1.5 0 0 0 2.12-2.12L18.122 16l6.44-6.44a1.5 1.5 0 0 0-2.122-2.12L16 13.878l-6.44-6.44a1.5 1.5 0 1 0-2.12 2.122L13.878 16l-6.44 6.44a1.5 1.5 0 0 0 2.122 2.12L16 18.122z"
        clip-rule="evenodd"
    />
</svg>
